export const genOrderedArarry = ({from = 1, to = 1, space = 1, preffix = '', suffix = ''} = {}) => {
  let res = []
  for (let i = from; i < to + 1; i = i + space) {
    res.push(preffix + i.toString() + suffix)
  }
  return res
}

export const genOrderedELETableFilter = (args) => {
  if (args.label) {
    return args.label.map((label, index) => {
      return {
        'text': label,
        'value': args.value[index]
      }
    })
  }
  let filterArray
  if (Array.isArray(args)) {
    filterArray = args
  } else {
    filterArray = genOrderedArarry(args)
  }
  let res = filterArray.map((item, index) => {
    return {'text': item, 'value': index + 1}
  })
  return res
}

const tableHeadData = [
  {
    label: '等级',
    prop: 'level',
  },
  {
    label: '课次',
    prop: 'lesson',
  },
  {
    label: '题目名称',
    prop: 'name',
  },
  {
    label: '题目用途',
    prop: 'purpose',
  },
  {
    label: '学年',
    prop: 'semester',
  },
  {
    label: '学期',
    prop: 'term',
  },
  {
    label: '支持分享',
    prop: 'support_share',
  },
  {
    label: '定稿状态',
    prop: 'final',
  }
]

const filterData = [
  [
    'lesson', { from: 1, to: 21 }
  ],
  [
    'name', []
  ],
  [
    'purpose', ['课中弹题', '随堂测']
  ],
  [
    'support_share', ['是', '否']
  ],
  [
    'semester', ['18-19', '19-20', '20-21', '21-22', '22-23', '23-24', '24-25'],
    
  ],
  [
    'term', ['秋', '寒', '春', '暑']
  ],
  [
    'frozen', ['已冻结', '未冻结']
  ],
  [
    'final', ['已定稿', '未定稿']
  ],
  [
    'level', {
      label: ['临时课程', 'level0', 'level1', 'level2', 'level3', 'level4'],
      value: [ -1, 0, 1, 2, 3, 4]
    }
  ],
  [
    'topic', { from: 1, to: 10}
  ]
]

const scratchFilterData = new Map(filterData)
const scratchFilter = new Map()
for (let [key, value] of scratchFilterData) {
  scratchFilter.set(key, genOrderedELETableFilter(value))
}
export {
  scratchFilter
}